import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00039AntenneTypeEnum } from '../../../P00039/Enum/P00039AntenneTypeEnum';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00045TimeZoneTypeEnum } from '../../P00045TimeZoneTypeEnum';

@Component({
  selector: 'app-p00045-installation-fuseau-horaire',
  templateUrl: './p00045-installation-fuseau-horaire.component.html',
  styleUrls: ['./p00045-installation-fuseau-horaire.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00045InstallationFuseauHoraireComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039AntenneTypeEnum = P00039AntenneTypeEnum;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00045TimeZoneTypeEnum = P00045TimeZoneTypeEnum;
}
